(() => {
  if (window.kixboxProductDiscountBadgeInitialized) return;
  window.kixboxProductDiscountBadgeInitialized = true;

  const mediaBadgeClass = 'product__media-discount-badge';

  function syncBadge(productInfo) {
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;
    const media =
      gallery.querySelector('.product__media-item.is-active .product__media') ||
      gallery.querySelector('.product__media');
    if (!media) return;

    const source = productInfo.querySelector(
      '.product__info-container .price--on-sale .price__badge-sale'
    );
    const current = gallery.querySelector(`.${mediaBadgeClass}`);
    const label = source?.textContent?.trim();

    if (!source || !label) {
      current?.remove();
      return;
    }

    if (source.getAttribute('aria-hidden') !== 'true') {
      source.setAttribute('aria-hidden', 'true');
    }

    const badge = current || document.createElement('span');
    if (!current) {
      badge.className = `badge price__badge-sale ${mediaBadgeClass}`;
      media.prepend(badge);
    } else if (badge.parentElement !== media) {
      media.prepend(badge);
    }

    if (badge.textContent !== label) badge.textContent = label;
    const ariaLabel = source.getAttribute('aria-label') || label;
    if (badge.getAttribute('aria-label') !== ariaLabel) {
      badge.setAttribute('aria-label', ariaLabel);
    }
  }

  function watchProduct(productInfo) {
    if (productInfo.dataset.discountBadgeObserved === 'true') return;
    productInfo.dataset.discountBadgeObserved = 'true';
    syncBadge(productInfo);

    const observer = new MutationObserver(() => syncBadge(productInfo));
    observer.observe(productInfo, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
  }

  function initialize(scope = document) {
    scope.querySelectorAll('product-info').forEach(watchProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
